import { connect } from 'react-redux'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import {
  getFeedRecentListFilteredByTeam,
  getFeedPendingGetRecent,
  getFeedPendingGetRecentLoadMore,
  getFeedLoadedGetRecent,
  getFeedLastUnreadStoryAuthor,
} from 'store/entities/feed/selectors'
import {
  getIdentityUserData,
  isOrganizationHasReactions,
  isOrganizationHasStories,
  getIdentityTeams,
  getIdentityOrganizationTeamOnly,
} from 'store/entities/identity/selectors'
import {
  feedRecentScroll,
  feedRecent,
  setFeedEventLikeOld,
  setFeedStoryLikeOld,
  setReaction,
  updateReaction,
  feedStoryActivity,
  removeUnreadStoryAuthor,
} from 'store/entities/feed/actions'
import FeedRecentList from './FeedRecentList'

const mapStateToProps = state => ({
  identity: getIdentityUserData(state),
  loaded: getFeedLoadedGetRecent(state),
  recentList: getFeedRecentListFilteredByTeam(state),
  pending: getFeedPendingGetRecent(state),
  pendingLoadMore: getFeedPendingGetRecentLoadMore(state),
  showStories: isOrganizationHasStories(state),
  showReactions: isOrganizationHasReactions(state),
  unreadStoryAuthor: getFeedLastUnreadStoryAuthor(state),
  teams: getIdentityTeams,
  isTeamOnly: getIdentityOrganizationTeamOnly,
})

const mapDispatchToProps = {
  handleScroll: ({ currentTarget }) => feedRecentScroll(currentTarget),
  handleSetFeedEventLikeOld: index => setFeedEventLikeOld(index),
  handleSetFeedStoryLikeOld: index => setFeedStoryLikeOld(index),
  onRequest: feedRecent.get.request,
  setStoryReaction: (emoji, activityUserStoryId, user) => setReaction({ emoji, activityUserStoryId, user }),
  setEventReaction: (emoji, eventId, user) => setReaction({ emoji, eventId, user }),
  updateReaction: (reaction, emoji) => updateReaction({ reaction, emoji }),
  isOrganizationHasStories,
  loadStoryActivity: (activityUserStoryId, activityId) =>
    feedStoryActivity.get.request({ activityUserStoryId, activityId }),
  hideNotification: removeUnreadStoryAuthor,
}

const mergeProps = ({ loaded, ...stateProps }, { onRequest, ...dispatchProps }, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onRequest: !loaded ? onRequest : () => {},
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(withDidMountRequest(FeedRecentList))
